import { apiFetch } from "../_common";

export interface McpTokenItem {
  id: string;
  label: string;
  createdAt: string;
  revokedAt: string | null;
}

export interface CreatedMcpToken {
  tokenId: string;
  token: string;
  label: string;
  createdAt: string;
}

const managementHeaders = (code: string): Record<string, string> => ({
  "x-mcp-management-code": code,
});

async function requestMcpApi<T>(url: string, options?: RequestInit): Promise<T> {
  try {
    return await apiFetch<T>(url, options);
  } catch (error) {
    const detail = error instanceof Error ? error.message : String(error);
    let body: unknown;
    try {
      body = JSON.parse(detail);
    } catch {
      throw new Error(`MCP management request failed: ${detail}`, { cause: error });
    }
    if (typeof body === "object" && body !== null && "error" in body) {
      const apiError = body.error;
      if (typeof apiError === "object" && apiError !== null && "message" in apiError && typeof apiError.message === "string") {
        throw new Error(apiError.message);
      }
    }
    throw new Error(`MCP management request failed: ${detail}`, { cause: error });
  }
}

export async function listMcpTokens(code: string): Promise<McpTokenItem[]> {
  const result = await requestMcpApi<{ tokens: McpTokenItem[] }>("/api/mcp/tokens", {
    headers: managementHeaders(code),
  });
  return result.tokens;
}

export function createMcpToken(code: string, label: string): Promise<CreatedMcpToken> {
  return requestMcpApi<CreatedMcpToken>("/api/mcp/tokens", {
    method: "POST",
    headers: { ...managementHeaders(code), "Content-Type": "application/json" },
    body: JSON.stringify({ label }),
  });
}

export function revokeMcpToken(code: string, tokenId: string): Promise<{ revoked: true }> {
  return requestMcpApi<{ revoked: true }>(`/api/mcp/tokens/${encodeURIComponent(tokenId)}/revoke`, {
    method: "POST",
    headers: managementHeaders(code),
  });
}
